import { Component, OnInit } from '@angular/core';
import {UntypedFormControl} from "@angular/forms";
import {User} from "../../models/user.model";
import {Observable} from "rxjs";
import {map, startWith} from "rxjs/operators";

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnInit {

  myControl = new UntypedFormControl();
  allItems: any[];
  filteredOptions: Observable<User[]>;

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        // @ts-ignore
        map(value => typeof value === 'string' ? value : value.name),
        // @ts-ignore
        map(name => name ? this._filter(name) : this.allItems.slice())
      );
  }

  displayFn(user: User): string {
    return user && user.name ? user.name : '';
  }

  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.allItems.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

}
